export default process.env.ENVCFG === 'cit' ?
  [
    {
      path: 'visualregression/bopoffer',
      getComponent(location, callback) {
        import(/* webpackChunkName: "visualregression" */ './containers/BopOnOffer')
          .then(component => callback(null, component.default));
      },
    },
    {
      path: 'visualregression/boptypical',
      getComponent(location, callback) {
        import(/* webpackChunkName: "visualregression" */ './containers/BopTypical')
          .then(component => callback(null, component.default));
      },
    }]
  : [];
